import { DateUtils } from '@ocean/utils'
import { UserUtils } from 'utils'
import { VirtualEventSchedule } from 'modules/virtualClassrooms/manager/Schedules/types/list'
import {
  ShowType,
  ScheduleStatus,
  SchedulesFilterItems,
} from 'modules/virtualClassrooms/manager/Schedules/types/list'

class ScheduleListUtils {
  getFilteredSchedules(
    schedules: VirtualEventSchedule[],
    filters: SchedulesFilterItems
  ): VirtualEventSchedule[] {
    const { showType, status } = filters
    let scheduleList = [...schedules]

    if (showType.value === ShowType.Own) {
      const { login } = UserUtils.getUserAccountInfo()
      scheduleList = scheduleList.filter(
        ({ createdBy }: VirtualEventSchedule) => createdBy === login
      )
    }

    return scheduleList.filter(({ startDate }: VirtualEventSchedule) => {
      const scheduleStartDate = DateUtils.convertUTCDateToLocalDate(startDate)

      if (status.value === ScheduleStatus.Past) return new Date(scheduleStartDate) <= new Date()
      return new Date(scheduleStartDate) > new Date()
    })
  }
}

export default new ScheduleListUtils()
